function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback, useEffect, useState } from 'react';
import Log from '@deephaven/log';
import { getWindowParent } from '@deephaven/utils';
import { MSG_REQUEST_SET_THEME } from "./ThemeModel.js";
import { isExternalThemeData, isExternalThemeEnabled, parseExternalThemeData, requestExternalThemeData } from "./ThemeUtils.js";
var logger = Log.module('useExternalTheme');
/**
 * If external theme is configured via `theme=EXTERNAL_THEME_KEY` query param,
 * handle `postMessage` communication to retrieve the theme data from the parent
 * Window. The hook will also listen for `MSG_REQUEST_SET_THEME` messages from
 * the parent and current Window to allow explicitly setting the theme.
 */
export function useExternalTheme() {
  var _useState = useState(() => {
      var isEnabled = isExternalThemeEnabled();
      return {
        isEnabled,
        isPending: isEnabled
      };
    }),
    _useState2 = _slicedToArray(_useState, 2),
    result = _useState2[0],
    setResult = _useState2[1];

  /** Parse external theme data and update the result */
  var handleExternalThemeData = useCallback(externalThemeData => {
    var themeData = parseExternalThemeData(externalThemeData);
    setResult({
      isEnabled: true,
      isPending: false,
      themeData
    });
  }, []);
  useEffect(() => {
    if (!result.isEnabled) {
      return;
    }
    logger.debug('Requesting external theme data');

    /** Parent or current Window can explicitly set the theme */
    function onMessage(event) {
      var parent = getWindowParent();

      // Allow messages from parent or current window
      if (event.source !== window && event.source !== parent) {
        return;
      }
      if (event.data.message === MSG_REQUEST_SET_THEME) {
        if (isExternalThemeData(event.data.payload)) {
          handleExternalThemeData(event.data.payload);
        }
      }
    }
    window.addEventListener('message', onMessage);

    /** Request initial theme data from parent window */
    requestExternalThemeData().then(handleExternalThemeData).catch(err => {
      logger.error(err);
      setResult({
        isEnabled: true,
        isPending: false
      });
    });
    return () => {
      window.removeEventListener('message', onMessage);
    };
  }, [handleExternalThemeData, result.isEnabled]);
  return result;
}
export default useExternalTheme;
//# sourceMappingURL=useExternalTheme.js.map